<template>
  <div>
    <b-button :variant="collection.id ? 'link' : 'primary'" class="btn-rounded"
              @click.prevent.stop="showForm = true">
            <span v-if="collection.id">
                <i class="fas fa-ellipsis-h text-dark"/>
            </span>
      <span v-else>
                Create Collection
            </span>
    </b-button>

    <b-modal :title="collection.id ? 'Edit Collection' : 'Create Collection'"
             hide-footer
             v-model="showForm"
             @hide="error = null">

      <b-alert :show="!!error" variant="danger" v-html="error"/>

      <b-form @submit.prevent="submit">

        <b-form-group :label="`COLLECTION NAME (MAX ${maxNameChars} CHAR.)`">
          <b-form-input v-model="name" autofocus maxlength="20" required/>
        </b-form-group>

        <b-form-group :label="`COLLECTION DESCRIPTION (MAX ${maxDescriptionChars} CHAR.)`">
          <b-form-textarea v-model="description" maxlength="60"/>
        </b-form-group>

        <b-form-group label="STATUS">
          <b-form-select v-model="status" :options="statusOptions"/>
        </b-form-group>

        <b-form-group label="CUSTOMERS" v-if="status === 'customer'">
          <organizations v-model="organizations" :initial-options="organizations"/>
        </b-form-group>

        <b-form-group label="FULL SEARCH URL" v-if="status === 'search'">
          <b-form-textarea v-model="searchQuery"/>
        </b-form-group>

        <b-form-group v-if="featuredAllowed">
          <b-form-checkbox v-model="featured">
            FEATURED
          </b-form-checkbox>
        </b-form-group>

        <b-form-group v-if="mainAllowed">
          <b-form-checkbox v-model="main">
            MAIN
          </b-form-checkbox>
        </b-form-group>



        <div class="d-flex align-items-center"
             :class="collection.id ? 'justify-content-between' : 'justify-content-end'">
          <div class="d-flex align-items-center gap-1">
            <i class="cursor-pointer text-danger fas fa-trash-alt"
               v-if="collection.id"
               v-b-tooltip
               title="Delete Collection"
               @click="deleteCollection"/>

            <b-button v-if="status==='lightbox' && collection.shareable_url" class="p-0" variant="link" v-b-tooltip title="Copy Link to Clipboard" @click="copyLink">
              <i class="fas fa-copy"></i>
            </b-button>
          </div>

          <b-button type="submit"
                    variant="primary"
                    class="btn-rounded"
                    :disabled="name.length === 0">
            {{ collection.id ? 'Update Collection' : 'Create Collection' }}
          </b-button>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import GeneralMixins from "../../../mixins/GeneralMixins";
import Organizations from "./Organizations";

export default {
  props: ['url', 'collection'],

  watch: {
    status(val) {
      if (val === 'lightbox') {
        this.featured = false
        this.main = false
      }
    }
  },

  data() {
    return {
      name: this.collection.name || '',
      description: this.collection.description || '',
      showForm: false,
      error: null,
      maxNameChars: 20,
      maxDescriptionChars: 60,
      organizations: this.collection.organizations || [],
      featured: this.collection.featured || false,
      main: this.collection.main || false,
      status: this.collection.status || 'draft',
      searchQuery: this.collection.search_query || ''
    }
  },

  mixins: [GeneralMixins],
  components: {Organizations},

  computed: {
    featuredAllowed() {
      return this.status !== 'lightbox'
    },

    mainAllowed() {
      return this.status !== 'lightbox'
    },

    statusOptions() {
      return [
        {value: 'draft', text: 'Draft'},
        {value: 'curated', text: 'Curated'},
        {value: 'search', text: 'Standard'},
        {value: 'customer', text: 'Customer'},
        {value: 'lightbox', text: 'Lightbox'},
      ]
    },

    params() {
      return {
        collection: {
          name: this.name,
          description: this.description,
          featured: this.featured,
          status: this.status,
          organization_ids: this.organizations.map(c => c.id),
          search_query: this.status === 'search' ? this.searchQuery : null,
          main: this.main
        }
      }
    },
  },

  methods: {
    copyLink() {
      navigator.clipboard.writeText(this.collection.shareable_url)
      this.showToast(`Link was copied to clipboard`)
    },

    submit() {
      const promise = this.collection.id ? this.updateCollection : this.createCollection;
      promise().then(fulfilled => {
        location.reload()
      }, rejected => {
        this.error = this.getErrorMessagesHtml(rejected.body)
      });
    },

    createCollection() {
      return this.$http.post(this.url, this.params)
    },

    updateCollection() {
      return this.$http.patch(this.url, this.params)
    },

    deleteCollection() {
      if (confirm("Are you sure you want to delete this collection?")) {
        this.$http.delete(this.url).then(fulfilled => {
          location.reload();
        }, rejected => {
          this.showErrorToast("There was an error while deleting this collection");
        })
      }
    }
  }
}
</script>